import { registerPlugin, WebPlugin } from '@capacitor/core'

import type { StoreProduct } from '../payments/types'

type NativeStoreProduct = Omit<StoreProduct, 'planId'>

export interface RuStoreNativePurchase {
  status: string
  purchaseId?: string
  invoiceId?: string
  productId?: string
  productType?: 'CONSUMABLE_PRODUCT' | 'SUBSCRIPTION'
}

export interface RuStorePaymentsPlugin {
  getAvailability(): Promise<{ available: boolean; status: string }>
  getProducts(): Promise<{ products: NativeStoreProduct[]; missingProductIds: string[] }>
  purchase(options: {
    productId: string
    orderId: string
    developerPayload: string
    appUserId: string
  }): Promise<RuStoreNativePurchase>
  acknowledgePurchase(options: { purchaseId: string }): Promise<{ purchaseId: string; status: string }>
  openSubscriptions(): Promise<{ status: string }>
}

class RuStorePaymentsWeb extends WebPlugin implements RuStorePaymentsPlugin {
  private failUnavailable(): never {
    throw Object.assign(new Error('RuStore payments are unavailable in browser'), { code: 'rustore_unavailable' })
  }

  async getAvailability(): Promise<{ available: boolean; status: string }> {
    return { available: false, status: 'rustore_unavailable' }
  }

  async getProducts(): Promise<{ products: NativeStoreProduct[]; missingProductIds: string[] }> { return this.failUnavailable() }
  async purchase(): Promise<RuStoreNativePurchase> { return this.failUnavailable() }
  async acknowledgePurchase(): Promise<{ purchaseId: string; status: string }> { return this.failUnavailable() }
  async openSubscriptions(): Promise<{ status: string }> { return this.failUnavailable() }
}

export const RuStorePayments = registerPlugin<RuStorePaymentsPlugin>('RuStorePayments', {
  web: () => Promise.resolve(new RuStorePaymentsWeb()),
})
